import React from "react";
//import { ScaleBox } from "../styles/View/View.styled";
import { Slider } from "@mui/material";

// import useMediaQuery from "@mui/material/useMediaQuery";

export default function ScaleSlider(props: ScaleSliderPorps) {
  // const matches = useMediaQuery("(min-width:1100px)");
  const style = {
    color: "var(--blue)",
    width: "100%",
    '& .MuiSliderThumb': {
      height: "20px",
      width: "20px",}
  };

  return (
      <div style={{width:"100%"}}>
        <Slider
          size="small"
          // size={props.size}
          style={style}
          value={typeof props.scale === "number" ? props.scale : 0}
          onChange={props.handleSliderChange}
          // step={10}
          min={30}
          max={props.max}
          defaultValue={95}
        />
      </div>
  );
}

